var render = function render(){var _vm=this,_c=_vm._self._c;return _c('viewport',[_c('div',[_c('div',{staticClass:"loading-msg"},[(!_vm.Pcwxlogin)?_c('div',{staticClass:"loading-dots"},[_c('span',{staticClass:"fi fi-rr-eyes"})]):_vm._e(),_c('div',[_c('span',[_vm._v(_vm._s(_vm.loginmsg))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }